<template>
  <div class="academic-years">
    <lenon-list-page
      title="Other Income"
      :columns="columns"
      :rows="filteredOtherIncomes"
      :table-loading="tableLoading"
      :show-create="false"
      :show-refresh="false"
      :show-search="true"
      :show-details="true"
      search-placeholder="Search"
    >
      <template slot="table-header">
        <div
          v-responsive="$store.getters['app/smallScreen']"
          class="col-12"
        >
          <b-collapse
            id="income"
          >
            <div class="row">
              <div class="col-md-6">
                <lenon-select
                  v-model="selectedAcademicYearId"
                  placeholder="Academic Year"
                  :options="academicYears"
                  label-name="name"
                  value-name="id"
                />
              </div>
              <div class="col-md-6">
                <lenon-select
                  v-model="selectedTermId"
                  placeholder="Select Term"
                  :options="filteredTerms"
                  label-name="name"
                  value-name="id"
                />
              </div>
              <div class="col-md-6">
                <lenon-select
                  v-model="selectedCategoryId"
                  placeholder="Filter by Category"
                  :options="categoriesWithAll"
                  label-name="name"
                  value-name="id"
                />
              </div>
              <div class="col-md-6">
                <lenon-button
                    icon="SettingsIcon"
                    label="Categories"
                    tool-tip-text="Manage Expense Categories(CRUD)"
                    class="mb-1"
                    variant="outline-primary"
                    @onClick="showExpenseCategoryModal()"
                />
              </div>
              <div class="col-md-6">
                <lenon-button
                  icon="SettingsIcon"
                  label="Other Income"
                  tool-tip-text="Manage Other Income(CRUD)"
                  class="mb-1"
                  @onClick="showOtherIncomeModal()"
                />
              </div>
            </div>
          </b-collapse>
        </div>
        <div class="col-12">
          <div class="row mb-1">
            <div class="col-md-4">
              <strong>Total Income:
                <b-badge
                  variant="light-success"
                  style="font-size: 15px;"
                >
                  <small>{{ $store.getters['auth/currency'] }}</small>{{ totalIncome | currency }}
                </b-badge>
              </strong>
            </div>
          </div>
        </div>
      </template>
      <template #category="{row}">
        {{ getCategory(row.item.income_category_id) }}
      </template>
      <template #amount="{row}">
        {{ row.item.amount | currency }}
      </template>
      <template slot="right-extra-header-actions">
        <div
          v-responsive="$store.getters['app/largeScreen']"
          class="d-flex align-self-center align-items-start"
        >
          <lenon-select
            v-model="selectedAcademicYearId"
            placeholder="Academic Year"
            :options="academicYears"
            label-name="name"
            value-name="id"
            class="mr-1"
          />
          <lenon-select
            v-model="selectedTermId"
            placeholder="Select Term"
            :options="filteredTerms"
            label-name="name"
            value-name="id"
            class="mr-1"
          />
          <lenon-select
            v-model="selectedCategoryId"
            placeholder="Filter by Category"
            :options="categoriesWithAll"
            label-name="name"
            value-name="id"
            class="mr-1"
          />
          <lenon-button
              icon="SettingsIcon"
              label="Categories"
              tool-tip-text="Manage Expense Categories(CRUD)"
              class="mr-1"
              variant="outline-primary"
              @onClick="showExpenseCategoryModal()"
          />
          <lenon-button
            icon="SettingsIcon"
            label="Other Income"
            tool-tip-text="Manage Other Income(CRUD)"
            class=""
            @onClick="showOtherIncomeModal()"
          />
        </div>
        <div
          v-responsive="$store.getters['app/smallScreen']"
          class="d-flex align-self-center align-items-center"
        >
          <lenon-button
            v-b-toggle.income
            icon-only
            icon="MoreVerticalIcon"
            variant="flat-primary"
          />
        </div>
      </template>
      <template #index="{row}">
        {{ row.index + 1 }}
      </template>
    </lenon-list-page>

    <other-income-setup
      :modal-opened="otherIncomeModalOpened"
      @modalClosed="closeModal('otherIncome')"
    />
    <expense-category-setup :modal-opened="expenseCategoryModalOpened" @modalClosed="closeModal('category')"/>
  </div>
</template>

<script>
import LenonButton from '@/lenon/components/LenonButton.vue'
import showToast from '@/lenon/mixins/showToast'
import { FETCH_OTHER_INCOMES_Q } from '@/graphql/queries'
import LenonListPage from '@/lenon/components/LenonListPage.vue'
import logData from '@/libs/log'
import OtherIncomeSetup from '@/views/finance/other-income/OtherIncomeSetup.vue'
import LenonDropdownItem from '@/lenon/components/LenonDropdownItem'
import LenonDropdown from '@/lenon/components/LenonDropdown'
import LenonSelect from '@/lenon/components/LenonSelect'
import { VBToggle, BCollapse, BBadge } from 'bootstrap-vue'
import ExpenseCategorySetup from '@/views/finance/expenses/ExpenseCategorySetup'

export default {
  name: 'OtherIncomes',
  components: {
    ExpenseCategorySetup,
    LenonSelect,
    LenonDropdown,
    LenonDropdownItem,
    LenonListPage,
    OtherIncomeSetup,
    LenonButton,
    BBadge,
    BCollapse,
  },
  directives: {
    'b-toggle': VBToggle,
  },
  mixins: [showToast],
  data() {
    return {
      otherIncomeModalOpened: false,
      tableLoading: false,
      selectedAcademicYearId: null,
      selectedTermId: null,
      selectedCategoryId: null,
      totalIncome: 0.00,
      expenseCategoryModalOpened: false,
      columns: [
        {
          key: 'index',
          label: '#',
        },
        {
          key: 'title',
          label: 'Title',
        },
        {
          key: "category",
          label: "Category"
        },
        {
          key: 'amount',
          label: `Amount (${this.$store.getters['auth/currency']})`,
        },
        {
          key: 'date',
          label: 'Income Date',
        },
        {
          key: 'details',
          label: 'Details',
        },
      ],
    }
  },
  computed: {
    categories(){
      return this.$store.getters['earnings/categories']
    },
    otherIncomes() {
      return this.$store.getters['earnings/otherIncome']
    },
    terms() {
      return this.$store.getters['termsClasses/terms']
    },
    academicYears() {
      return this.$store.getters['termsClasses/academicYears']
    },
    filteredTerms() {
      return this.terms.filter(t => this.termIds.includes(t.id))
    },
    termIds() {
      if (this.academicYear) {
        return this.academicYear.terms.map(t => t.term_id)
      }
      return []
    },
    academicYear() {
      return this.academicYears.find(ay => ay.id === this.selectedAcademicYearId)
    },
    categoriesWithAll() {
      return this.categories
    },
    filteredOtherIncomes() {
      if (!this.selectedCategoryId) {
        return this.otherIncomes
      }
      return this.otherIncomes.filter(income => income.income_category_id === this.selectedCategoryId)
    },
  },
  watch: {
    selectedTermId() {
      this.fetchOtherIncomes()
    },
    selectedAcademicYearId() {
      this.fetchOtherIncomes()
    },
    filteredOtherIncomes(val) {
      this.totalIncome = 0.00
      for (let i = 0; i < val.length; i++) {
        this.totalIncome += val[i].amount
      }
    },
  },
  mounted() {
    this.fetchOtherIncomes()
    this.getCategories()
  },
  methods: {
    showExpenseCategoryModal() {
      this.expenseCategoryModalOpened = true
    },
    getCategory(id){
      const cat = this.categories.find((c)=>c.id===id)
      if(cat){
        return cat.name
      }
      return "N/A"
    },
    getCategories(){
      this.$http.get('finance/categories').then((res)=>{
        this.$store.commit('earnings/setCategories', res.data)
      })
    },
    closeModal(type) {
      // eslint-disable-next-line default-case
      switch (type) {
        case 'otherIncome':
          this.otherIncomeModalOpened = false
          break
        case 'category':
          this.expenseCategoryModalOpened = false
      }
    },
    showOtherIncomeModal() {
      this.otherIncomeModalOpened = true
    },

    fetchOtherIncomes() {
      this.tableLoading = true
      this.$apollo.query({
        query: FETCH_OTHER_INCOMES_Q,
        variables: {
          term_id: this.selectedTermId,
          academic_year_id: this.selectedAcademicYearId,
        },
      })
        .then(res => {
          this.$store.commit('earnings/setOtherIncomes', res.data)
        }).catch(err => {
          logData(err)
          this.showError('Failed to load other income')
        }).finally(() => {
          this.tableLoading = false
        })
    },
  },
}
</script>
